const fr = {
  100000001:'Informations clés',
  100000002:'Nom du token',
  100000003:'Créateur de la copie',
  100000004:"Heure de création de l'instance",
  100000005:'Informations de base  ',
  100000006:'Blockchain/protocole associé  ',
  100000007:'Adresse du contrat intelligent  ',
  100000008:"Date d'émission",
  100000009:'Offre totale',
  100000010:'Offre en circulation',
  100000011:'Capitalisation boursière',
  100000012:'Données de marge',
  100000013:'Informations sur les réseaux sociaux',
  100000014:'Site web',
  100000015:'Livre blanc',
  100000016:'Explorateur blockchain  ',
  100000017:'Évaluation du projet',
  100000018:'Classement',
  100000019:'Top',
  100000020:'Code security',
  100000021:'Operation Performance',
  100000022:'Market Stability',
  100000023:'Governance Strength',
  100000024:'Project Health',
  100000025:'Community Trust',
  100000026:'Dernière mise à jour',
  100000027:'Note de sécurité  ',
  100000028:'Note de sécurité du contrat  ',
  100000029:'Statistiques des projets à risque  ',
  100000030:'Détails du code du contrat  ',
  100000031:"Taxe d'achat  ",
  100000032:'Taxe de vente  ',
  100000033:'Est un honeypot  ',
  100000034:'Peut être mint à nouveau  ',
  100000035:"Existence d'une liste noire  ",
  100000036:"Existence d'une liste blanche  ",
  100000037:'Est anti-baleine  ',
  100000038:"Peut modifier le taux d'imposition  ",
  100000039:'Est open source  ',
  100000040:'Existence de détenteurs cachés  ',
  100000041:"Peut s'autodétruire  ",
  100000042:'Est un contrat proxy  ',
  100000043:'Peut modifier le solde  ',
  100000044:'Peut exécuter des appels externes  ',
  100000045:'Peut récupérer la propriété  ',
  100000046:"Existence d'une période de refroidissement pour les transactions  ",
  100000047:'Peut suspendre les transferts  ',
  100000048:'Propriété non renoncée  ',
  100000049:'Est anti-baleine ajustable  ',
  100000050:'Trop de décimales  ',
  100000051:'Méthodes publiques de Mint et Burn  ',
  100000052:"Brûler des tokens met à jour l'offre totale  ",
  100000053:'Brûler des tokens met à jour le solde  ',
  100000054:'Transférer à soi-même augmente le solde  ',
  100000055:'Transférer plus de tokens que le solde sera invalide  ',
  100000056:"Le solde n'est pas mis à jour lors du transfert  ",
  100000057:'Le solde du destinataire sera consommé  ',
  100000058:'Appeler TransferFrom au-delà du solde échouera  ',
  100000059:"La méthode BurnFrom met à jour l'offre totale  ",
  100000060:"Détecter la taxe d'achat du jeton. Au-dessus de 5% est considéré comme un taux de taxe élevé.",
  100000061:'Détecter la taxe de vente du jeton. Au-dessus de 5% est considéré comme un taux de taxe élevé.',
  100000062:'Vérifier si le jeton est une arnaque de type honeypot.',
  100000063:'Vérifier si plus de jetons peuvent être créés.',
  100000064:"Vérifier si le jeton a une liste noire qui peut restreindre les utilisateurs d'échanger ou de transférer des jetons.",
  100000065:'Vérifier si le jeton a une liste blanche qui permet aux adresses de contourner les restrictions.',
  100000066:'Vérifier si le jeton a des mécanismes anti-baleines.',
  100000067:'Vérifier si le jeton a une taxe et si cette taxe peut être modifiée par des rôles privilégiés.',
  100000068:'Vérifier si le jeton a été vérifié sur un explorateur de blockchain.',
  100000069:'Vérifier si le jeton a un propriétaire caché qui peut manipuler le contrat, même si la propriété semble avoir été renoncée.',
  100000070:"Vérifier si le jeton peut s'autodétruire.",
  100000071:"Vérifier si le jeton est un contrat proxy qui délègue les appels de fonction à un contrat d'implémentation.",
  100000072:'Vérifier si le solde du jeton peut être modifié par des rôles privilégiés.',
  100000073:'Vérifier si le jeton appelle des contrats externes.',
  100000074:'Vérifier si le jeton a une porte dérobée pour reprendre la propriété.',
  100000075:'Vérifier si le jeton a un mécanisme de délai de transfert.',
  100000076:'Vérifier si le commerce du jeton peut être suspendu par des rôles privilégiés.',
  100000077:'Vérifier si le privilège du propriétaire a été renoncé.',
  100000078:'Vérifier si les mécanismes anti-baleines du jeton peuvent être modifiés par des rôles privilégiés.',
  100000079:'Vérifier si la valeur de retour de la fonction decimals() est supérieure ou égale à 5.',
  100000080:"Vérifier si appeler les fonctions mint() et burn() en tant qu'utilisateurs aléatoires entraînera un revert.",
  100000081:'Vérifier si appeler la fonction burn() mettra à jour correctement le totalSupply.',
  100000082:"Vérifier si appeler la fonction burnFrom() mettra à jour correctement l'allocation.",
  100000083:"Vérifier si appeler la fonction transfer() avec le destinataire identique à l'expéditeur de la transaction augmentera le solde de l'expéditeur.",
  100000084:'Vérifier si appeler la fonction transfer() avec un montant supérieur au solde échouera.',
  100000085:"Vérifier si l'allocation du dépensier est mise à jour en conséquence après avoir appelé la fonction transferFrom().",
  100000086:"Vérifier si appeler la fonction transferFrom() utilisera le solde du dépensier.",
  100000087:"Vérifiez si l'allocation est mise à jour correctement après avoir appelé transferFrom(), ou si la transaction est annulée si le montant est invalide.",
  100000088:"Vérifiez si l'appel de la fonction burnFrom() mettra à jour correctement le totalSupply.",
  100000089:"Vérifier si l'autorité d'émission existe.",
  100000090:"Vérifier si l'autorité de gel existe.",
  100000091:'Examiner si les métadonnées peuvent être modifiées.',
  100000092:'Critique  ',
  100000093:'Majeur  ',
  100000094:'Moyen  ',
  100000095:'Mineur  ',
  100000096:'Informatif',
  100000097:'Permission de mint renoncée  ',
  100000098:'Permission de gel renoncée  ',
  100000099:'Peut modifier les métadonnées du token  ',

  100000100:'Votre rapport annuel est en cours de génération…',
  100000101:'Bienvenue à',
  100000102:'Votre récapitulatif de 2024',
  100000103:'Je suis votre guide personnel.',
  100000104:'Revoyons les traces que nous avons laissées en 2024.',
  100000105:'Ouvrir le rapport',
  100000106:'Il y a {num} jours, les rouages du destin ont commencé à tourner',
  100000107:"{userName} Notre histoire commence à partir d'ici",
  100000108:'Pour un rêve commun, nous courons ensemble',
  100000109:'Étoile de profit d\'investissement',
  100000110:'Aperçu annuel du rendement cumulé du portefeuille',
  100000111:'Vous êtes en avance sur <em class="normal bold" style="color: #2AFF0A;">{percentage}</em>des utilisateurs',
  100000112:'Au cours de l\'année dernière, nous avons ressenti le <em class="normal bold" style="color: #FFF;">FOMO</em> causé par les inscriptions et apprécié la joie de la <em class="normal bold" style="color: #FFF;">meme montée</em>. Maintenant, plongeons ensemble dans vos souvenirs.',
  100000113:'Trader d\'élite',
  100000114:'Transactions cumulées en 2024 (fois)',
  100000115:'Montant total des transactions ($)',
  100000116:'Vous avez dépassé <em class="normal bold" style="color: #FFC72B;">{percentage}%</em> des utilisateurs.',
  100000117:'Ce n\'est pas seulement une accumulation de chiffres, mais un badge de votre vision et sagesse.',
  100000118:'Chaque transaction est un pas vers Web3.0.',
  100000119:'Étoile montante',
  100000120:'La baisse maximale du Bitcoin en 2024 a atteint <em class="normal">34%</em>, les ajustements du marché sont devenus normaux. Votre performance d\'investissement n\'est qu\'un résultat temporaire, et l\'avenir est toujours plein de possibilités!',
  100000121:'Investisseur stable',
  100000122:'Chaque observation et attente sont pour accueillir un moment plus précis. Nous espérons voir votre miracle d\'investissement et de bénéfice en 2025.',
  100000123:'Le jeton que vous avez le plus échangé en 2024.',
  100000124:'Si vous n\'oubliez pas, il y aura sûrement une réponse',
  100000125:'La concentration et l\'effort brillent dans les résultats de la négociation.',
  100000126:'Fluctuation de Bitcoin sur SuperEx en 2024',
  100000127:'Votre variation du prix du Bitcoin en 2024',
  100000128:'Félicitations! Vos actifs ont augmenté! Continuez vos efforts l\'année prochaine.',
  100000129:'Vous n\'avez pas détenu de Bitcoin en 2024.',
  100000130:'Investisseur exceptionnel',
  100000131:'Investisseur stable',
  100000132:'Investisseur apprenant',
  100000133:'Données de trading du tableau principal',
  100000134:'revenu($)',
  100000135:'Taux de rendement annuel (%)',
  100000136:'Profit Leader (%)',
  100000137:'Données de trading de contrats',
  100000138:'Vous avez démontré de la sagesse dans votre stratégie d\'investissement. Merci d\'avoir choisi de nous accompagner !',
  100000139:'Mettre les voiles à nouveau',
  100000140:'Vous n\'avez pas seulement suivi les tendances, vous en êtes aussi un précurseur ! Vous avez lancé des pièces dans la zone libre <em class="normal bold" style="color: #FFF;">{num1}</em> fois et échangé <em class="normal bold" style="color: #FFF;">{num2}</em> fois. Vous, qui aimez les produits innovants, êtes le véritable aventurier !',
  100000141:'Super influenceur social',
  100000142:'Merci de nous avoir apporté <em class="normal bold" style="color: #FFF;">{num}</em> nouveaux visages. La plateforme prospère grâce à vos recommandations, et nous espérons avoir plus d\'amis partageant les mêmes idées sur le chemin vers Web3.0.',
  100000143:'Nouvelle étoile de potentiel social',
  100000144:'Il y a <em class="normal bold" style="color: #FFF;">{num}</em> utilisateurs SuperEx qui gagnent jusqu\'à 40% de commissions sur les transactions en invitant des amis. Vous avez raté 2024, mais ce n\'est pas grave. Saisissez l\'opportunité en 2025.',
  100000145:'Partagez vos moments forts de l\'année ! Partagez avec votre communauté pour encourager plus de personnes à nous rejoindre, débloquer ensemble des récompenses exclusives et explorer le monde de la crypto.',
  100000146:"Invitez un ami pour obtenir une récompense d'une valeur de 10 USDT !",
  100000147:'Partager le rapport',
  100000148:'Voir à nouveau',
  100000149:'En 2024, vous étiez connu sur SuperEx comme',
  100000150:'Vous avez dépassé les utilisateurs de la plateforme:',
  100000151:'Marché principal Trading Spot Rendement Annuel',
  100000152:'Contrat Rendement Annuel',
  100000153:'Cette année, je suis une légende de l\'investissement!',
  100000154:'Code d\'invitation: {InviteCode}',
  100000155:'SuperEx.com - Web3.0 échange de  cryptomonnaies',
  100000156:'Cherchez la victoire dans la stabilité, montrez votre force!',
  100000157:'Cette année, nous avons accumulé de l\'expérience, l\'année prochaine sera encore plus excitante!',
  100000158:'Vous savez?',
  100000159:'La zone de libre échange de SuperEx est la plateforme de trading d\'Meme coins la plus populaire et la plus prometteuse au monde.',
  100000160:'2024, superex ajoute <em class="normal bold" style="color: #FFF;">{num}</em>nouveaux utilisateurs, comme nouvelle famille',
  100000161:'Votre rétrospective de 2024 et votre voyage vers des profits mille fois en 2025 sont sur le point de commencer.',
  100000162:'Ceci est une lettre d\'un membre senior de la famille Superex, enregistrant leurs bonnes nouvelles pour 2024.',
  100000163:'@to*** a acheté 1 BTC avec 1 USDT, avec un rendement allant jusqu\'à <em class="normal bold" style="color: #FFF;font-size:0.7rem">9,958,800%</em>.',
  100000164:'@1o*** a obtenu 1 ETH pour 1 USDT, avec un rendement atteignant <em class="normal bold" style="color: #FFF;font-size:0.7rem">487,000%</em>.',
  100000165:'@we*** a obtenu 1 iPhone 15 pour 1 USDT, avec un taux de rendement de <em class="normal bold" style="color: #FFF;font-size:0.7rem">92,800%</em>.',
  100000166:'Il y a encore plus de choses passionnantes…',
  100000167:'Petites sommes, gros retours, et un gameplay en constante évolution rendent chaque participation pleine de surprises.',
  100000168:'Spot, contrat, gestion de patrimoine…',
  100000169:'La lettre est longue, continuons à lire',
  100000170:"Émission cumulative de tokens initiaux de <span class='inline-block relative bold' style='color: #FFFFFF;font-size:1rem'>150+</span>,SuperEx continuera de s'efforcer de créer plus d'opportunités pour les utilisateurs.",
  100000171:'Aperçu annuel du portefeuille Taux de P&L cumulés du compte',
  100000172:'Aperçu du portefeuille Compte Montant annuel des gains et des pertes <em class="normal bold {classNum}">{num}</em>',
  100000173:'Vous êtes en avance sur <em class="normal bold" style="color: #FFF;font-size:1rem">{percentage}%</em> des utilisateurs. Votre sagesse en matière de stratégies d\'investissement est impressionnante.',
  100000174:'2025-SuperEx',
  100000175:'Chemin vers la richesse',
  100000176:'Ouvrir quand prêt',
  100000177:'Salut! Je suis un nouvel ami de SuperEx.',
  100000178:'Rejoignez SuperEx et explorez des possibilités infinies. Inscrivez-vous pour des avantages utilisateurs.',
  100000179:'Utilisateur @vb*** participe à la négociation sur le marché principal au comptant, avec un taux de rendement cumulé de près de <em class="normal bold" style="color: #FFF;font-size:0.7rem">10,400%</em> pour $ATOM.',
  100000180:'Utilisateur @xi*** participe à la négociation sur le marché principal au comptant, le rendement cumulatif de $PIPE est proche de <em class="normal bold" style="color: #FFF;font-size:0.7rem">7,400%</em>',
  100000181:"L'utilisateur @09*** participe au trading principal du $ATH avec un rendement cumulé de près de <em class='normal bold' style='color: #FFF;font-size:0.7rem'>3,500%</em>.",
  100000182:'Nous avons hâte d\'être témoins de votre première transaction sur l\'échange WEB3 et de commencer un chapitre passionnant!',
  100000183:'1USD, Super Start, 1000+ spot, effet de levier 150X, inscription 1000X...',
  100000184:'Expérimentez divers secteurs à haut rendement !',
  100000185:'Les hausses et les baisses sont temporaires, mais la conviction perdure.',
  100000186:'À travers la volatilité, témoignez de la véritable valeur.',
  100000187:"Votre rapport annuel 2024 n'a pas encore été généré. Bienvenue dans une nouvelle année d'aventures commerciales ! Accumulez plus d'interactions pour débloquer le résumé exclusif de l'année prochaine.",
  100000188:'L’histoire annuelle des crypto-monnaies 2024 n’attend que vous ! Revivez les moments forts de 2024 avec SuperEx, venez partager vos moments exclusifs ! ',
  100000189:'L’histoire annuelle des crypto-monnaies 2024 n’attend que vous !',
  100000190: "Ouvrez l'application SuperEx pour consulter le “Rapport annuel”",
  100000191: '{year}année {month}mois {day}jour (UTC)',
  100000192: 'Acheteur',
  100000193: 'Code de commande',
  100000194: 'Je',
  100000195: 'Liste des participants',
  100000196: 'Les articles de monnaie numérique ont été émis. Veuillez contacter le service client pour les articles physiques',
  100000197: 'Achat réussi',
  100000198: '{name}obtenu avec succès',
  100000199: 'Acheter',
  100000200: 'Tout est chargé',
  100000201: 'Félicitations à {name} pour avoir gagné {shop} !',
  100000202: "L'utilisateur {name} a participé avec succès à {shop}!"

}
export default fr


// WEBPACK FOOTER //
// ./src/i18n/langs/languageAllen/fr.js